import { FunctionComponent, useCallback } from 'react';
import { oneLine } from 'common-tags';
import Image from 'next/image';
import LinkNext from 'next/link';
import { useDispatch } from 'react-redux';

import { Link, Price, Quantity, Tag } from '@/atoms';

import { removeLineFromCart, updateLineFromCart } from '@/lib/carts';

import { TypeCartLineProps } from './types';
import { LinkVariant } from '@/atoms/link/types';

/**
 * CartLine
 */
export const CartLine: FunctionComponent<TypeCartLineProps> = ({
  className = '',
  image,
  link,
  description,
  regular,
  sale,
  name,
  isGift = false,
  isEditable = true,
  quantity = 1,
  lineCart,
  product,
  carts
}: TypeCartLineProps) => {
  const distpach = useDispatch();
  const qName = `quantity_${product.variants[0].variant_id}`;

  const submitQuantity = useCallback((quantity) => (
    distpach(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      updateLineFromCart({
        lineId: lineCart,
        itemId: product?.variants[0].variant_id,
        product: product,
        quantity: quantity,
      })
    )
  ), [lineCart, product, distpach]);

  return (
    <div
      className={oneLine`
      flex items-center w-full border-b border-secondary-200 p-4
      ${className}
    `}
    >
      <div className="flex items-center w-full">
        <LinkNext
          href={link}
          prefetch={false}
          className="md:w-[92px] md:h-[92px] w-16 h-16 relative block flex-shrink-0"
        >
          <Image
            src={image.src}
            alt={image.alt ?? 'Imagen del producto'}
            draggable="false"
            className="w-full h-full object-cover object-center absolute inset-0"
            sizes="100vw"
            fill
          />
        </LinkNext>

        <div className="pl-3 gap-y-4 md:py-3 flex flex-col justify-between flex-grow">
          <div className="flex flex-row justify-between items-start">
            <div>
              <LinkNext
                href={link}
                prefetch={false}
                className={oneLine`
                  mb-4 text-body
                  ${isGift ? 'text-body--m' : 'text-body--l'}
                `}
              >
                {name}
              </LinkNext>

              <p className="text-body text-body--s text-text-secondary mb-4">
                {description}
              </p>
            </div>

            {isEditable && (
              <Link
                as="button"
                variant={LinkVariant.POSITIVE}
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onClick={() => {
                  distpach(
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    removeLineFromCart({ lineId: lineCart, product })
                  );
                }}
              >
                Eliminar
              </Link>
            )}
          </div>

          <div
            className={oneLine`
            flex flex-row gap-x-5 items-end
            ${isGift ? 'justify-end' : 'justify-between'}
          `}
          >
            {isGift ? (
              <Tag colors="info">Regalo</Tag>
            ) : (
              <>
                Cantidad:{' '}

                {isEditable ? (

                  <Quantity
                    name={qName}
                    min={1}
                    initialValue={quantity}
                    onClick={submitQuantity}
                    disabled={carts.loading}
                  />
                )
                  : (
                    quantity
                  )}
                <Price
                  regular={regular}
                  sale={sale}
                  position="below"
                  className="text-right"
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

CartLine.displayName = 'CartLine';
